
var sprite = require("C:/git/annenberg-petspace-petbook/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 72.36 13.09\" id=\"pull-tab-top\" ><title>Asset 2</title><g data-name=\"Layer 2\"><path d=\"M19.15 11.68H1.38a1.37 1.37 0 1 1 0-2.75h17.77a1.37 1.37 0 1 1 0 2.75zM20.15 5.39H1.38a1.38 1.38 0 0 1 0-2.75h18.77a1.38 1.38 0 0 1 0 2.75zM71 11.68H53.21a1.37 1.37 0 1 1 0-2.75H71a1.37 1.37 0 1 1 0 2.75zM71 5.39H52.21a1.38 1.38 0 0 1 0-2.75H71a1.38 1.38 0 0 1 0 2.75zM45.26 13.09a1.37 1.37 0 0 1-1-.47l-8-9.16-8 9.16a1.37 1.37 0 1 1-2.07-1.81L35.15.47a1.37 1.37 0 0 1 1-.47 1.38 1.38 0 0 1 1 .47l9.14 10.33a1.38 1.38 0 0 1-1 2.28z\"/></g></symbol>";
module.exports = sprite.add(image, "pull-tab-top");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pull-tab-top.svg
// module id = 310
// module chunks = 1